import { render } from "./foreman.vue?vue&type=template&id=470b31f6&scoped=true"
import script from "./foreman.vue?vue&type=script&lang=js"
export * from "./foreman.vue?vue&type=script&lang=js"

import "./foreman.vue?vue&type=style&index=0&id=470b31f6&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470b31f6"]])

export default __exports__